/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import importerModule from 'app/mixins/ImporterModule.js';
import ImportSearch from 'app/components/Importer/ImportSearch.jsx';
import ImportResults from 'app/components/Importer/ImportResults.jsx';
import ImportHints from 'app/components/Importer/ImportHints.jsx';
import Loading from 'app/components/common/Loading.jsx';
import FeatureUpgradeComponent from 'app/components/Subscription/FeatureUpgradeComponent.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import * as _ from 'underscore';
import { compose } from 'redux';

class Importer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentService: 0,
            currentSearch: '',
            hints: {},
            selectedSocials: [],
            importComplete: false,
            gaID: 0,
            connection: {},
            connections: [],
            emptySearch: false,
            socials: [],
            twitterOutputs: [],
            searchError: null,
            importError: null,
            wordpressError: null,
        };

        this.onSearch = this.onSearch.bind(this);
        this.triggerSearch = this.triggerSearch.bind(this);
        this.onHintSelect = this.onHintSelect.bind(this);
        this.onSearchTypeChange = this.onSearchTypeChange.bind(this);
        this.onStartImport = this.onStartImport.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            constants = props.app.config.constants;

        if (props.socials.list.length && !_.isEqual(props.socials.list, state.socials)) {
            let twitterOutputs = [],
                temp = _.filter(props.socials.list, function(social){
                    return constants.POST_SVC_TWITTER == social.psID;
                });

            if (temp.length) {
                for (let key in temp) {
                    twitterOutputs.push(temp[key].id);
                }
            }

            nextState.socials = props.socials.list;
            nextState.twitterOutputs = twitterOutputs;
        }

        if (state.gaID) {
            for (let i = 0; i < props.connections.length; ++i) {
                if (state.gaID === props.connections[i].id && !_.isEqual(props.connections[i], state.connection)) {
                    nextState.connection = props.connections[i];
                }
            }
        }

        let errors = props.getApiErrors(['BULK_HINTS']);
        if (errors.length) {
            nextState.searchError = errors[0].errors;
        }
        errors = props.getApiErrors(['BULK_POST']);
        if (errors.length) {
            nextState.importError = errors[0].errors;
        }
        errors = props.getApiErrors(['BULK_RESULTS']);
        if (errors.length) {
            nextState.wordpressError = errors[0].errors;
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {

		if (this.props.router.query !== null && this.props.router.query.state) {
			let state = this.props.router.query.state;
			this.props.authReturnHandler.apply(this, [{
				path: '/content/import'
			}, () => {
                this.props.resetAuthState();
            }]);
		}

        this.props.resetBulk();
        this.props.getSocials();
        this.props.getConnections();
        this.props.getCategories();

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.router.params.id && prevState.gaID != this.props.router.params.id && this.props.connections.length) {
            this.setState({
                gaID: parseInt(this.props.router.params.id, 10)
            }, () => {
                this.props.getConnection(this.state.gaID);
            });
        }

        if (prevProps.bulk.completedImports < this.props.bulk.completedImports) {
            this.setState({
                importComplete: true,
                selectedSocials: []
            });
        }

        if (this.state.searchError === undefined && this.state.importError === undefined && this.state.wordpressError === undefined) {
            if ((prevProps.app.loading.BULK_RESULTS === true && this.props.app.loading.BULK_RESULTS === false) && props.bulk.searchResults.length === 0) {
                this.setState({
                    emptySearch: true
                });
            }
        }

    }

    componentWillUnmount() {

        this.props.deleteApiError(['BULK_HINTS', 'BULK_POST', 'BULK_RESULTS']);

    }

    onConnectionChange() {
        let connection = this.state.connection,
            connections = ConnectionStore.getConnections();

        if (this.state.gaID > 0) {
            connection = ConnectionStore.getConnection(this.state.gaID);
        }

    }

    onHintSelect(e) {

        let service = e.currentTarget.dataset.service,
            resultQuery = e.currentTarget.dataset.resultquery;

        e.preventDefault();
        e.stopPropagation();

        this.props.getBulkResults(service, resultQuery);

        this.setState({
            currentService: service,
            hints: {},
            searchError: null
        });

    }

    onSearch(e, search) {

        this.props.deleteApiError(['BULK_HINTS', 'BULK_POST', 'BULK_RESULTS']);
        if (search !== '') {
            if (search !== this.state.currentSearch) {
                e.persist();
                this.props.resetBulk();
                this.triggerSearch(e, search);
            }
        } else {
            this.props.resetBulk();
            this.setState({
                currentSearch: '',
                hints: {},
                searchError: null
            });
        }

    }

    triggerSearch(e, search) {

        if (e) {
            e.preventDefault();
        }

        this.props.deleteApiError(['BULK_HINTS', 'BULK_POST', 'BULK_RESULTS']);
        let data = {},
            searchTerm = typeof search !== "undefined" ? search : this.state.currentSearch,
            constants = this.props.app.config.constants;

        if (this.state.gaID !== 0) {
            this.props.getBulkResults(constants.BULK_SVC_WORDPRESS, searchTerm, this.state.connection.id);
        } else {
            data = {
                query: searchTerm
            };
            // don't bother running an empty search
            if (searchTerm === '') {
                return;
            }
            this.props.getBulkHints(data);
        }

        this.setState({
            currentSearch: searchTerm,
            currentService: 0,
            emptySearch: false,
            searchError: null
        });

    }

    onSearchTypeChange(item, e) {
        let gaID = this.state.gaID;

        gaID = item.id;

        if (item.id === -1) {
            this.props.router.navigate("/content/connections");
            gaID = 0;
        } else if (item.id === 0) {
            if (this.props.router.location.pathname.match("wordpress")) {
                this.props.router.navigate("/content/import");
            }
        } else {
            this.props.router.navigate("/content/import/wordpress/" + item.id);
        }

        this.setState({
            connection: {},
            gaID,
            hints: {},
            currentService: 0,
            currentSearch: '',
            wordpressError: null
        });

    }

    onStartImport() {

        if (this.state.importComplete) {
            this.setState({
                importComplete: false
            });
        }

    }

    render() {
        let content = null,
            results = null,
            constants = this.props.app.config.constants,
            loading = (
                <Loading/>
            );

        if (this.props.user.perms && Object.keys(this.props.user.perms).length === 0) {
            return (
                <Content main={loading}/>
            );
        }

        if (this.props.user.perms.resources && !this.props.user.perms.resources.bulkImport) {
            content = (
                <FeatureUpgradeComponent
                    {...this.props}
                    context="contentImport"/>
            );
            return (
                <Content main={content}/>
            );
        }

        if (this.props.app.loading.BULK_RESULTS) {
            results = (
                <div className="import-loader empty">
                    <Loading label="Searching..."/>
                </div>
            );
        } else if (this.props.bulk.searchResults.length > 0 || this.state.searchError !== null) {
            if (this.state.searchError) {
                let serverSaid = this.state.searchError.validation?.query;
                results = (
                    <div className="import-loader error">
                        Aw geez, we couldn't get results for you.{serverSaid ? ` The server said: ${serverSaid}` : ''}
                    </div>
                );
            } else {
                results = (
                    <ImportResults
                        {...this.props}
                        items={this.props.bulk.searchResults}
                        service={this.state.currentService}
                        chooseSocials={this.onChooseSocials}
                        selectedSocials={this.state.selectedSocials}
                        onImportItems={this.onImportItems}
                        importComplete={this.state.importComplete}
                        categories={this.props.categories}
                        importError={this.state.importError}
                        onSocialsSelected={this.onSocialsSelected}
                        socials={this.state.socials}
                        twitterOutputs={this.state.twitterOutputs} />
                );
            }
        } else if (Object.keys(this.props.bulk.hints).length > 0) {
            results = (
                <ImportHints
                    {...this.props}
                    onClick={this.onHintSelect}
                    onAddSocial={this.onAddSocial} />
            );
        } else if (this.state.wordpressError !== null) {
            results = (
                <div className="import-loader error">
                    We didn't get a response from WordPress, <a href="#" onClick={this.triggerSearch}>Try your search again right now!</a>
                </div>
            );
        } else if (this.state.emptySearch) {
            results = (
                <div className="import-results-wrapper empty">
                    <div className="empty-message">
                        There were no results for your query.
                    </div>
                </div>
            );
        } else {
            results = (
                <div className="import-results-wrapper empty"></div>
            );
        }

        content = (
            <div className="importer-main">
                <ImportSearch
                    {...this.props}
                    onSearch={this.onSearch}
                    gaID={this.state.gaID}
                    connection={this.state.connection}
                    onSearchTypeChange={this.onSearchTypeChange}
                    triggerSearch={this.triggerSearch} />
                {results}
            </div>
        );

        return (
            <Content header={null} main={content}/>
        );
    }
}

Importer.displayName = "Importer";

const enhance = compose(
    ComponentWithContext,
    importerModule
);

export default enhance(Importer);
